import dynamic from "next/dynamic";
const ButtonLink = dynamic(() => import("@/Components/ButtonLink"),{ssr: true});
const CardDots = dynamic(() => import("../CardDots"),{ssr: true});

interface BlueCardsProps {
  classname?: string;
  title: string;
  details: string;
  label: string;
  link: string;
}

const BlueCards: React.FC< BlueCardsProps> = ({ classname,
  title,
  details,
  label,
  link,
 }) => {
  return (
    <div className={classname}>
      <div
        className="py-8 px-6 card-new-blue lg:pb-28 pb-[83px] shadow-[0_16px_72px_-10px_#001A2D3D] bg-blue-50 relative h-full overflow-hidden hover:after:translate-x-4 after:transition-transform after:duration-300
    after:bg-[url(/images/blue-card-right.png)] after:content-[''] after:absolute after:w-[74px] after:h-[192px] after:bottom-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom
    before:bg-[url(/images/blue-card-shards.webp)] before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center group"
      >
        <CardDots />
        <div className="relative z-10">
          <h6 className="text-heading-6 font-bold text-primary-text">
            {title}
          </h6>
          <p className="text-subtitle-2 font-semibold text-secondary-text mt-3 line-clamp-4">
            {details}
          </p>
          {link && (
            <ButtonLink
              className="xl:mt-[19px] lg:mt-4 mt-5 font-semibold text-primary-text"
              label={label}
              href={link}
              color="text-primary-text"
              stroke="stroke-primary-text"
            ></ButtonLink>
          )}
        </div>
      </div>
    </div>
  );
};
export default BlueCards;
